import { BaseEntity, Default, MemoizeGetters, toDate, Transform } from "./base";
import moment from "moment";

@MemoizeGetters
export class Photo extends BaseEntity {
  url: string;
  label: string;

  @Transform(toDate)
  @Default([])
  takenAt: Date;

  get takenAtFormatted() {
    return moment(this.takenAt).format('llll');
  }

  get labelFormatted() {
    return this.label.replace(/_/g,' ');
  }
}
